<div class="dialog-header">
  <h3 class="dialog__title">Imprint</h3>
  <button
    class="close-button"
    mat-icon-button
    tabindex="-1"
    cdkFocusInitial
    (click)="closeDialog()"
    id="imprintModal-header-button-close"
  >
    <i class="bosch-ic bosch-ic-clickable bosch-ic-close"></i>
  </button>
</div>

<div class="dialog-content">
  <span
    ><b>{{ "name-and-address" | translate }}</b></span
  ><br />
  <span>Bosch Soluções Integradas Brasil Ltda.</span><br />
  <span>Edifício 106/Térreo - BISB</span><br />
  <span>Via Anhanguera, km 98</span><br />
  <span>Vila Boa Vista</span><br />
  <span>13.065-900 – Campinas – SP</span><br />
  <br />
  <span
    ><b>{{ "contact-subtitle" | translate }}</b></span
  ><br />
  <span
    ><a href="mailto:suporte.frotas@br.bosch.com"
      >suporte.frotas&#64;br.bosch.com</a
    ></span
  ><br />
  <span>+55 (19) 2103-1731</span><br />
  <br />
  <span><b>CNPJ</b></span
  ><br />
  <span>23.306.242/0001-03</span><br />
  <br />
  <span
    ><b>{{ "open-source-licenses" | translate }}</b></span
  ><br />
  <a
    class="footerNav__link"
    download
    rel="noopener"
    (click)="generatePDFPath('pdfBackendMaster')"
  >
    OSS Obligation Report - BISB SmartFleetplatform V1.0 Backend Master </a
  ><br />
  <a
    class="footerNav__link"
    download
    rel="noopener"
    (click)="generatePDFPath('pdfMaster')"
  >
    OSS Obligation Report - BISB SmartFleetplatform V1.0 Master
  </a>
</div>
